import './App.css'
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Dashboard from './screens/dashboard';
import Tank from './screens/tank';
import User from './screens/users';

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path='/' element={<Dashboard />} />
          <Route path='/tank' element={<Tank />} />
          <Route path='/user' element={<User />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
